import React, { useState } from 'react';
import { Download, CheckCircle, AlertCircle, ChevronDown, ChevronUp, Calendar, Mail, Edit2, Send, User } from 'lucide-react';
export function InitechApplicationView() {
  const [expandedRef, setExpandedRef] = useState<string | null>(null);
  const [expandedGuarantor, setExpandedGuarantor] = useState<string | null>(null);
  const tradeReferences = [{
    id: 'techsupply',
    company: 'TechSupply Solutions',
    status: 'completed',
    statusText: 'Completed on April 10, 2025',
    emailsSent: '1 email sent',
    contact: {
      name: 'Robert California',
      phone: '(512) 555-0300',
      email: 'r.california@techsupply.com'
    },
    details: {
      yearsAsCustomer: 6,
      creditLimit: '$30,000',
      currentBalance: '$18,000',
      paymentHabits: 'Prompt (Net 30)',
      recommended: 'Yes',
      responseDate: 'April 10, 2025'
    }
  }, {
    id: 'servermax',
    company: 'ServerMax Distributors',
    status: 'completed',
    statusText: 'Completed on April 11, 2025',
    emailsSent: '1 email sent',
    contact: {
      name: 'Andy Bernard',
      phone: '(512) 555-0301',
      email: 'a.bernard@servermax.com'
    },
    details: {
      yearsAsCustomer: 8,
      creditLimit: '$25,000',
      currentBalance: '$15,000',
      paymentHabits: 'Prompt (Net 30)',
      recommended: 'Yes',
      responseDate: 'April 11, 2025'
    }
  }, {
    id: 'cloudware',
    company: 'CloudWare Systems',
    status: 'completed',
    statusText: 'Completed on April 9, 2025',
    emailsSent: '1 email sent',
    contact: {
      name: 'Stanley Hudson',
      phone: '(512) 555-0302',
      email: 's.hudson@cloudware.com',
      address: '890 Tech Boulevard, Dallas TX 75201'
    },
    details: {
      yearsAsCustomer: 4,
      creditLimit: '$20,000',
      currentBalance: '$12,000',
      paymentHabits: 'Prompt (Net 30)',
      recommended: 'Yes',
      responseDate: 'April 9, 2025'
    }
  }];
  return <div className="space-y-6" data-id="element-1595" data-mp="ylu68o6lpjg3">
      {/* Application Header */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1596" data-mp="kvigux1ehysn">
        <div className="flex items-center justify-between mb-4" data-id="element-1597" data-mp="kto2k1kmx4xj">
          <div data-id="element-1598" data-mp="ptadu5gwkb3p">
            <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1599" data-mp="psr070yac8vh">
              Credit Application
            </h2>
            <div className="text-sm text-gray-600 space-y-1" data-id="element-1600" data-mp="aznoha7dkpco">
              <p data-id="element-1601" data-mp="fx770mb3voaf">
                <span className="font-semibold" data-id="element-1602" data-mp="fxp5zqp5kgm1">Started On:</span> April 8, 2025
              </p>
              <p data-id="element-1603" data-mp="1yh58tdcd0fq">
                <span className="font-semibold" data-id="element-1604" data-mp="1yzc0jxmqx1w">Submitted On:</span> April 12,
                2025
              </p>
              <p data-id="element-1605" data-mp="1waxaprybcajj">
                <span className="font-semibold" data-id="element-1606" data-mp="1wae437e458kt">Approved On:</span> April 15,
                2025
              </p>
            </div>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-1607" data-mp="217nzr4s3igh3">
            <Download className="w-4 h-4" data-id="element-1608" data-mp="26fdpei023llr" />
            DOWNLOAD PDF
          </button>
        </div>
      </div>

      {/* Applicant Details */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1609" data-mp="2k7afyhm2tng1">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1610" data-mp="2fdpo77b2tppa">
          Applicant Details
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-1611" data-mp="2u2ltiwlr0om7">
          <div data-id="element-1612" data-mp="2p5lper8glvxq">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1613" data-mp="2p40toyaes6ya">
              Name
            </label>
            <p className="text-gray-900" data-id="element-1614" data-mp="334bjrz3w9hie">Milton Waddams</p>
          </div>
          <div data-id="element-1615" data-mp="2z2zzm93shohl">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1616" data-mp="2z4kww6hhnlj5">
              Company
            </label>
            <p className="text-gray-900" data-id="element-1617" data-mp="18r3vkqafc45q">Initech Corporation</p>
          </div>
          <div data-id="element-1618" data-mp="14qjxnki10wij">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1619" data-mp="14r1r69db0wmr">
              Role
            </label>
            <p className="text-gray-900" data-id="element-1620" data-mp="168qox7aj9lki">Accounts Payable</p>
          </div>
          <div data-id="element-1621" data-mp="1b3xqa8gbye69">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1622" data-mp="1b7lhh0yayoht">
              Department
            </label>
            <p className="text-gray-900" data-id="element-1623" data-mp="1k66zmuzv41i2">Accounting</p>
          </div>
          <div data-id="element-1624" data-mp="1k42vcby1x0h9">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1625" data-mp="1k3t0ob22a558">
              Email
            </label>
            <div className="flex items-center gap-2" data-id="element-1626" data-mp="rh8avf18i13s">
              <p className="text-gray-900" data-id="element-1627" data-mp="rhrkm8gqdj6q">m.waddams@initech.com</p>
              <CheckCircle className="w-4 h-4 text-green-600" data-id="element-1628" data-mp="wfjnfxiwyppp" />
            </div>
          </div>
          <div data-id="element-1629" data-mp="117ky5f0fo8dm">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1630" data-mp="1182zgq1ydcse">
              Phone Number
            </label>
            <p className="text-gray-900" data-id="element-1631" data-mp="3pukvfqk2hlz">(512) 555-0199</p>
          </div>
        </div>

        {/* Email Verification */}
        <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg" data-id="element-1632" data-mp="17hbhoza5kx2">
          <div className="flex items-start gap-3" data-id="element-1633" data-mp="15em975ybvte">
            <CheckCircle className="w-5 h-5 text-green-600 mt-0.5" data-id="element-1634" data-mp="3setvebrjscgo" />
            <div data-id="element-1635" data-mp="3nefleo6dysg0">
              <div className="font-semibold text-gray-900 mb-1" data-id="element-1636" data-mp="3ndxu85ykz4ey">
                Email Verification
              </div>
              <p className="text-sm text-gray-700" data-id="element-1637" data-mp="3jcc7lsw8vbrk">
                Email verified and matches company domain.
              </p>
            </div>
          </div>
        </div>

        {/* IP Address */}
        <div className="mt-4" data-id="element-1638" data-mp="39mizx2z83gsl">
          <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1639" data-mp="39l7xp7lfeh3l">
            Location (IP Address)
          </label>
          <div className="flex items-center gap-2" data-id="element-1640" data-mp="2zpeljpbmcpmc">
            <p className="text-gray-900" data-id="element-1641" data-mp="2zqy1tfx9z0o4">Austin, TX (192.168.1.100)</p>
            <CheckCircle className="w-4 h-4 text-green-600" data-id="element-1642" data-mp="2vmhvxennvt8w" />
          </div>
        </div>

        {/* IP Verification */}
        <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg" data-id="element-1643" data-mp="2qoyjmkaixqjl">
          <div className="flex items-start gap-3" data-id="element-1644" data-mp="2h01cteoqr3ig">
            <CheckCircle className="w-5 h-5 text-green-600 mt-0.5" data-id="element-1645" data-mp="2l2fxm4bz0dcd" />
            <div data-id="element-1646" data-mp="2l3r1031i7j2y">
              <div className="font-semibold text-gray-900 mb-1" data-id="element-1647" data-mp="2l035wzgeuom4">
                IP Address Verification
              </div>
              <p className="text-sm text-gray-700" data-id="element-1648" data-mp="2c17y5ixpx6gp">
                Applicant location matches company headquarters.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Company Information */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1649" data-mp="34pdk290id1i4">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1650" data-mp="2q2amy3g3kuvb">
          Company Information
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-1651" data-mp="2uztz8xt8ixkm">
          <div data-id="element-1652" data-mp="2uy987i64pwri">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1653" data-mp="3iqg7oq75ijv5">
              Legal Business Name
            </label>
            <p className="text-gray-900" data-id="element-1654" data-mp="3nhy6p8pm6adh">Initech Corporation</p>
          </div>
          <div data-id="element-1655" data-mp="1c1eb887ew4j1">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1656" data-mp="1c0w58juy6bxx">
              DBA
            </label>
            <p className="text-gray-900" data-id="element-1657" data-mp="172bd77pumykk">Initech</p>
          </div>
          <div data-id="element-1658" data-mp="1kuhhnwjn3h46">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1659" data-mp="1kt6he6pekrht">
              Business Address
            </label>
            <p className="text-gray-900" data-id="element-1660" data-mp="1gtfpu0s1y7c8">
              4120 Freidrich Lane
              <br data-id="element-1661" data-mp="t3uxwsdx7zqt" />
              Austin, TX 78744
            </p>
          </div>
          <div data-id="element-1662" data-mp="o4qpw52qg822">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1663" data-mp="o5a53e100ice">
              Years in Business
            </label>
            <p className="text-gray-900" data-id="element-1664" data-mp="121ndlxnk19eq">33 years</p>
          </div>
          <div data-id="element-1665" data-mp="x3vn982k5vcn">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1666" data-mp="x3c1thdp8otv">
              Tax ID / EIN
            </label>
            <p className="text-gray-900" data-id="element-1667" data-mp="2dkq4i1p4epp3">**-***7291</p>
          </div>
          <div data-id="element-1668" data-mp="28jakmcyoip8a">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1669" data-mp="28lwnhzamkgk6">
              Industry
            </label>
            <p className="text-gray-900" data-id="element-1670" data-mp="2xl16w19y2m0y">Software & IT Services</p>
          </div>
        </div>
      </div>

      {/* Requested Credit Terms */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1671" data-mp="31ltfqtewmowp">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1672" data-mp="36dl6p51z2wnd">
          Requested Credit Terms
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-1673" data-mp="3bbd063i9mqto">
          <div data-id="element-1674" data-mp="3gbiu5qc0cpex">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1675" data-mp="3gazmr3jzhjf5">
              Requested Credit Limit
            </label>
            <p className="text-gray-900 text-lg font-semibold" data-id="element-1676" data-mp="3lbx1f65sbvbw">$75,000</p>
          </div>
          <div data-id="element-1677" data-mp="3pb5ue8t03p6e">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1678" data-mp="3pbnslaz84dgy">
              Payment Terms
            </label>
            <p className="text-gray-900" data-id="element-1679" data-mp="1qyxhx1yaagzc">Net 30</p>
          </div>
          <div data-id="element-1680" data-mp="1uyoh9u1vm5fh">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1681" data-mp="1uyg0hr2mufz0">
              Estimated Monthly Volume
            </label>
            <p className="text-gray-900" data-id="element-1682" data-mp="1io6vqx0no79k">$25,000 - $30,000</p>
          </div>
          <div data-id="element-1683" data-mp="1im3xxqt9h9ua">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1684" data-mp="1dokkuu8av33x">
              Purpose
            </label>
            <p className="text-gray-900" data-id="element-1685" data-mp="19o1p4p3adcwg">IT equipment and software licenses</p>
          </div>
        </div>
      </div>

      {/* Trade References */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1686" data-mp="26bf1th5wrkcn">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1687" data-mp="21ey1lolfpfj7">
          Trade References
        </h3>
        <div className="space-y-3" data-id="element-1688" data-mp="1xb9xjfw0h22p">
          {tradeReferences.map(ref => <div key={ref.id} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-1689" data-mp="1scykkwaf6bg9">
              {/* Collapsed Header */}
              <button onClick={() => setExpandedRef(expandedRef === ref.id ? null : ref.id)} className="w-full p-4 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-1690" data-mp="gy1stemup857">
                <div className="flex items-center gap-4" data-id="element-1691" data-mp="7roz2spa5sr6">
                  <span className="font-semibold text-gray-900" data-id="element-1692" data-mp="llpzdqvvrntn">
                    {ref.company}
                  </span>
                  <div className="flex items-center gap-3 text-sm text-gray-600" data-id="element-1693" data-mp="gs3l5ua2jbvq">
                    <div className="flex items-center gap-1" data-id="element-1694" data-mp="vhjb581rzdad">
                      <Calendar className="w-4 h-4" data-id="element-1695" data-mp="qkj690gnwgku" />
                      {ref.statusText}
                    </div>
                    {ref.emailsSent && <>
                        <span className="text-gray-300" data-id="element-1696" data-mp="10igs5hb1u1aa">•</span>
                        <div className="flex items-center gap-1" data-id="element-1697" data-mp="10g2wb68jol1o">
                          <Mail className="w-4 h-4" data-id="element-1698" data-mp="36bx6yqk1f5pi" />
                          {ref.emailsSent}
                        </div>
                      </>}
                  </div>
                </div>
                {expandedRef === ref.id ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-1699" data-mp="2w6z0bg2o02l6" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-1700" data-mp="2iftv7ygj2i3g" />}
              </button>

              {/* Expanded Content */}
              {expandedRef === ref.id && <div className="border-t border-gray-200 p-6 bg-gray-50" data-id="element-1701" data-mp="2nck9cg8rv3m8">
                  {/* Reference Information */}
                  <div className="mb-6" data-id="element-1702" data-mp="2dghbvnov7t5m">
                    <div className="flex items-center gap-2 mb-4" data-id="element-1703" data-mp="2dhiovxpfyppz">
                      <span className="font-semibold text-gray-900" data-id="element-1704" data-mp="1zhho0i96fiai">
                        Reference Information
                      </span>
                      <Edit2 className="w-4 h-4 text-indigo-600 cursor-pointer" data-id="element-1705" data-mp="24gb149kjx7a5" />
                    </div>
                    <div className="grid grid-cols-2 gap-6" data-id="element-1706" data-mp="3tswc6umjh9o5">
                      <div data-id="element-1707" data-mp="2nmurrcm23q5">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-1708" data-mp="2nwj7ai0c2tq">
                          Company Name
                        </label>
                        <p className="text-gray-900" data-id="element-1709" data-mp="3sdagjf3qm4bh">{ref.company}</p>
                      </div>
                      <div data-id="element-1710" data-mp="3ne78dlsgnhza">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-1711" data-mp="3nficjmptirqx">
                          Contact Name
                        </label>
                        <p className="text-gray-900" data-id="element-1712" data-mp="jy0hkfv59f7x">{ref.contact.name}</p>
                      </div>
                      <div data-id="element-1713" data-mp="eyxakpvlsyxb">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-1714" data-mp="eyni8vn36fog">
                          Contact Phone Number
                        </label>
                        <p className="text-gray-900" data-id="element-1715" data-mp="a5ueob3ctddy">{ref.contact.phone}</p>
                      </div>
                      <div data-id="element-1716" data-mp="579o73dwm82p">
                        <label className="text-sm text-gray-500 mb-1 block" data-id="element-1717" data-mp="12p01v3rp20uv">
                          Contact Work Email
                        </label>
                        <p className="text-gray-900" data-id="element-1718" data-mp="xwgjlti2ahjq">{ref.contact.email}</p>
                      </div>
                      {ref.contact.address && <div className="col-span-2" data-id="element-1719" data-mp="1a77mxqu6bgk9">
                          <label className="text-sm text-gray-500 mb-1 block" data-id="element-1720" data-mp="1aa3n7lthuhbv">
                            Company Address
                          </label>
                          <p className="text-gray-900" data-id="element-1721" data-mp="1k786ndvyfyoz">{ref.contact.address}</p>
                        </div>}
                    </div>
                  </div>

                  {/* Status-specific content */}
                  {ref.status === 'pending' && <div data-id="element-1722" data-mp="1xx20ybq8bb63">
                      <div className="font-semibold text-gray-900 mb-2" data-id="element-1723" data-mp="1xywirh67en5y">
                        Awaiting Response
                      </div>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-1724" data-mp="27vrho16e2pkr">
                        The reference request has been sent 2 times.
                      </p>
                      <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-1725" data-mp="2bxw7spxmp42n">
                        <Send className="w-4 h-4" data-id="element-1726" data-mp="34nxy2gpt33q6" />
                        SEND REMINDER
                      </button>
                    </div>}

                  {ref.status === 'completed' && ref.details && <div data-id="element-1727" data-mp="3edra1itv1kuy">
                      <div className="flex items-center gap-2 mb-4" data-id="element-1728" data-mp="3efbvmiy75tgo">
                        <div className="font-semibold text-gray-900" data-id="element-1729" data-mp="2qnn77dohxp50">
                          Reference Completed
                        </div>
                        <AlertCircle className="w-5 h-5 text-red-600" data-id="element-1730" data-mp="2zntjiw8gkj2l" />
                      </div>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-1731" data-mp="2up8e8iecn97a">
                        Response received on {ref.details.responseDate}
                      </p>
                      <div className="grid grid-cols-2 gap-x-12 gap-y-4 text-sm" data-id="element-1732" data-mp="ezxbbyidbhhw">
                        <div className="flex justify-between" data-id="element-1733" data-mp="9y7x69zumnpl">
                          <span className="text-gray-600" data-id="element-1734" data-mp="ifid5928sklp">
                            Years as Customer
                          </span>
                          <span className="font-medium text-gray-900" data-id="element-1735" data-mp="miwqfrysqmvg">
                            {ref.details.yearsAsCustomer}
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-1736" data-mp="dh72wx81c82y">
                          <span className="text-gray-600" data-id="element-1737" data-mp="115q1gl1a96hu">Credit Limit</span>
                          <span className="font-medium text-gray-900" data-id="element-1738" data-mp="165cn9iv6fv29">
                            {ref.details.creditLimit}
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-1739" data-mp="relw8d1et007">
                          <span className="text-gray-600" data-id="element-1740" data-mp="we88aj5i4a7f">Current Balance</span>
                          <span className="font-medium text-gray-900" data-id="element-1741" data-mp="1k4u9bqh38u7x">
                            {ref.details.currentBalance}
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-1742" data-mp="1yscawfzct8q4">
                          <span className="text-gray-600" data-id="element-1743" data-mp="1ypgeiw35ms3s">Payment Habits</span>
                          <span className="font-medium text-red-600" data-id="element-1744" data-mp="1ttixsonzbjqh">
                            {ref.details.paymentHabits}
                          </span>
                        </div>
                        <div className="flex justify-between col-span-2" data-id="element-1745" data-mp="1kri2vyg7x9rz">
                          <span className="text-gray-600" data-id="element-1746" data-mp="1ft8atwpsipal">Recommended</span>
                          <span className="font-medium text-red-600" data-id="element-1747" data-mp="1b2i1y9i5o4b5">
                            {ref.details.recommended}
                          </span>
                        </div>
                      </div>
                    </div>}

                  {ref.status === 'not-sent' && <div data-id="element-1748" data-mp="x2yttgpcgsyu">
                      <div className="font-semibold text-gray-900 mb-2" data-id="element-1749" data-mp="x15oc4qgwesf">
                        Ready to Send
                      </div>
                      <p className="text-sm text-gray-600 mb-4" data-id="element-1750" data-mp="s5qc1h83yqy4">
                        This trade reference request has not yet been sent to
                        the contact.
                      </p>
                      <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-1751" data-mp="3cre5z93swt44">
                        <Send className="w-4 h-4" data-id="element-1752" data-mp="3hppengid0xkr" />
                        SEND REFERENCE
                      </button>
                    </div>}
                </div>}
            </div>)}
        </div>

        {/* Additional Trade References */}
        <div className="mt-6 p-4 bg-gray-50 rounded-lg" data-id="element-1753" data-mp="2tzd21sc66cnu">
          <div className="font-semibold text-gray-900 mb-1" data-id="element-1754" data-mp="2ys65mcvwjeyc">
            Additional Trade References
          </div>
          <p className="text-sm text-gray-600 mb-4" data-id="element-1755" data-mp="21b7fd01k2dld">
            No additional references requested
          </p>
          <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-1756" data-mp="26a0q4kpgjqhu">
            <Send className="w-4 h-4" data-id="element-1757" data-mp="upg4chzwwlqd" />
            REQUEST ADDITIONAL TRADE REFERENCES
          </button>
        </div>
      </div>

      {/* Personal Guarantors */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1758" data-mp="18ml6i6wi90gc">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1759" data-mp="14lsw3abwcpih">
          Personal Guarantors
        </h3>
        <div className="space-y-3" data-id="element-1760" data-mp="1il10qiqtwpu2">
          {/* Bill Lumbergh - Completed */}
          <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-1761" data-mp="1dmzczkigk2c9">
            {/* Collapsed Header */}
            <button onClick={() => setExpandedGuarantor(expandedGuarantor === 'bill' ? null : 'bill')} className="w-full p-4 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-1762" data-mp="1sbvk9fcoxbbt">
              <div className="flex items-center gap-4" data-id="element-1763" data-mp="1wc74ws51zbna">
                <span className="font-semibold text-gray-900" data-id="element-1764" data-mp="2g13k9un99p1a">
                  Bill Lumbergh
                </span>
                <div className="flex items-center gap-3 text-sm text-gray-600" data-id="element-1765" data-mp="2kxtwg6vxw0hf">
                  <div className="flex items-center gap-1" data-id="element-1766" data-mp="26yc5plz32d5f">
                    <Calendar className="w-4 h-4" data-id="element-1767" data-mp="2b0z2806p8m8y" />
                    Completed on February 15, 2026
                  </div>
                  <span className="text-gray-300" data-id="element-1768" data-mp="1x9aqvz49y1t1">•</span>
                  <div className="flex items-center gap-1" data-id="element-1769" data-mp="1x7hlso9b7pn5">
                    <Mail className="w-4 h-4" data-id="element-1770" data-mp="2212k6hetelmv" />1 email sent
                  </div>
                </div>
              </div>
              {expandedGuarantor === 'bill' ? <ChevronUp className="w-5 h-5 text-gray-400" data-id="element-1771" data-mp="1s9y6dl0vl6tm" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-1772" data-mp="1eaq6epww1uod" />}
            </button>

            {/* Expanded Content */}
            {expandedGuarantor === 'bill' && <div className="border-t border-gray-200 p-6 bg-gray-50" data-id="element-1773" data-mp="1jbm58p2duqmx">
                {/* Guarantor Information */}
                <div className="mb-6" data-id="element-1774" data-mp="1mfr7canc3efh">
                  <div className="flex items-center gap-2 mb-4" data-id="element-1775" data-mp="1mgsjkig366ys">
                    <User className="w-4 h-4 text-gray-600" data-id="element-1776" data-mp="18gresrwpafe1" />
                    <span className="font-semibold text-gray-900" data-id="element-1777" data-mp="18iatwf6meke8">
                      Guarantor Information
                    </span>
                    <Edit2 className="w-4 h-4 text-indigo-600 cursor-pointer" data-id="element-1778" data-mp="214dl47xbby4l" />
                  </div>
                  <div className="grid grid-cols-2 gap-6" data-id="element-1779" data-mp="256qnqngrjfx5">
                    <div data-id="element-1780" data-mp="258bj2fawj2w2">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1781" data-mp="1rflvi6fq5pwu">
                        Full Name
                      </label>
                      <p className="text-gray-900" data-id="element-1782" data-mp="1wcm1yighkuoh">Bill Lumbergh</p>
                    </div>
                    <div data-id="element-1783" data-mp="2k2zltlox3n7z">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1784" data-mp="2k1og3gbww5e8">
                        Title
                      </label>
                      <p className="text-gray-900" data-id="element-1785" data-mp="2y91gi5yhrsom">VP Operations</p>
                    </div>
                    <div data-id="element-1786" data-mp="2u7y3dr7twar3">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1787" data-mp="2u6n0ruq4d91k">
                        Email
                      </label>
                      <p className="text-gray-900" data-id="element-1788" data-mp="37yb9do15tfds">b.lumbergh@initech.com</p>
                    </div>
                    <div data-id="element-1789" data-mp="330rv4o4gp2lu">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1790" data-mp="2fafjp3a0cnqi">
                        Phone
                      </label>
                      <p className="text-gray-900" data-id="element-1791" data-mp="2b9vmjzpfpk4d">(512) 555-0200</p>
                    </div>
                    <div data-id="element-1792" data-mp="2p8v6wv5wzcuq">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1793" data-mp="2pa6cn0ix6uoh">
                        Address
                      </label>
                      <p className="text-gray-900" data-id="element-1794" data-mp="4idy1br9i1dv">
                        4120 Freidrich Lane, Austin, TX 78744
                      </p>
                    </div>
                    <div data-id="element-1795" data-mp="3vofey0xwrp7f">
                      <label className="text-sm text-gray-500 mb-1 block" data-id="element-1796" data-mp="3vr1ou789ugst">
                        SSN
                      </label>
                      <p className="text-gray-900" data-id="element-1797" data-mp="bksyvtlnskey">***-**-8291</p>
                    </div>
                  </div>
                </div>

                {/* Guarantee Completed */}
                <div data-id="element-1798" data-mp="lji6mtjucohh">
                  <div className="flex items-center gap-2 mb-4" data-id="element-1799" data-mp="lk0bufohed1j">
                    <div className="font-semibold text-gray-900" data-id="element-1800" data-mp="3k1e0uqfvid8k">
                      Guarantee Completed
                    </div>
                    <CheckCircle className="w-5 h-5 text-green-600" data-id="element-1801" data-mp="3ozp6eoz4y1kz" />
                  </div>
                  <p className="text-sm text-gray-600 mb-4" data-id="element-1802" data-mp="3tza7b4xv8k0c">
                    Personal guarantee signed on February 15, 2026
                  </p>
                  <div className="grid grid-cols-2 gap-x-12 gap-y-4 text-sm" data-id="element-1803" data-mp="2mz5aqfa44vh">
                    <div className="flex justify-between" data-id="element-1804" data-mp="31ad1406xidny">
                      <span className="text-gray-600" data-id="element-1805" data-mp="369fuuohgkxgm">Guarantee Amount</span>
                      <span className="font-medium text-gray-900" data-id="element-1806" data-mp="2yqgdeodk5fzw">$75,000</span>
                    </div>
                    <div className="flex justify-between" data-id="element-1807" data-mp="2trdhpujgwm4l">
                      <span className="text-gray-600" data-id="element-1808" data-mp="2ts54qgz01bj9">Date Signed</span>
                      <span className="font-medium text-gray-900" data-id="element-1809" data-mp="2or92e7uapxfy">
                        February 15, 2026
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-1810" data-mp="2frlzfhlx4jks">
                      <span className="text-gray-600" data-id="element-1811" data-mp="2ft5j7i6s9crb">Guarantee Type</span>
                      <span className="font-medium text-gray-900" data-id="element-1812" data-mp="2azuh1ucx1k5q">
                        Unlimited
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-1813" data-mp="212ptpr7c3inc">
                      <span className="text-gray-600" data-id="element-1814" data-mp="2149b5l4q7zqp">Expiration</span>
                      <span className="font-medium text-gray-900" data-id="element-1815" data-mp="1w3v0dvbqqboz">None</span>
                    </div>
                  </div>
                </div>
              </div>}
          </div>
        </div>

        {/* Additional Personal Guarantors */}
        <div className="mt-6 p-4 bg-gray-50 rounded-lg" data-id="element-1816" data-mp="2guqrngi87mgi">
          <div className="font-semibold text-gray-900 mb-1" data-id="element-1817" data-mp="2lqpdawc66qd8">
            Additional Personal Guarantors
          </div>
          <p className="text-sm text-gray-600 mb-4" data-id="element-1818" data-mp="27zu9hygj2zgi">
            No additional guarantors requested
          </p>
          <button className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg text-sm font-semibold transition-colors" data-id="element-1819" data-mp="2bzuq9pr3nmqq">
            <Send className="w-4 h-4" data-id="element-1820" data-mp="232akq4m7f4ab" />
            REQUEST ADDITIONAL PERSONAL GUARANTORS
          </button>
        </div>
      </div>

      {/* Banking Information */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1821" data-mp="1t2thruyc74i1">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1822" data-mp="1t4wfz29n83xu">
          Banking Information
        </h3>
        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-1823" data-mp="3nh46m3exlynt">
          <div data-id="element-1824" data-mp="3ngkreugo1odh">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1825" data-mp="3nf051s4i9bqp">
              Bank Name
            </label>
            <p className="text-gray-900" data-id="element-1826" data-mp="17s5s42nb5ipm">Austin Community Bank</p>
          </div>
          <div data-id="element-1827" data-mp="17q2sqs09md88">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1828" data-mp="1ljk9y65hbdv3">
              Contact
            </label>
            <p className="text-gray-900" data-id="element-1829" data-mp="1gsbyl4kl9ifa">Jennifer Aniston</p>
          </div>
          <div data-id="element-1830" data-mp="1vhqaajbn0bxu">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1831" data-mp="1vh8grugd0btm">
              Type of Account
            </label>
            <p className="text-gray-900" data-id="element-1832" data-mp="1qhluywmgtn97">Business Checking</p>
          </div>
          <div data-id="element-1833" data-mp="24iy6mvulf2pa">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1834" data-mp="24hde1bru9tu2">
              Account #
            </label>
            <p className="text-gray-900" data-id="element-1835" data-mp="1zjv0t96sgsg9">987654321</p>
          </div>
          <div data-id="element-1836" data-mp="a3lwzr76k7ol">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1837" data-mp="a56r5fpl1olx">
              Email
            </label>
            <p className="text-gray-900" data-id="element-1838" data-mp="5757askc1l9e">j.aniston@austinbank.com</p>
          </div>
          <div data-id="element-1839" data-mp="258v7xnvoo7px">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1840" data-mp="259egwf3cvlrt">
              City
            </label>
            <p className="text-gray-900" data-id="element-1841" data-mp="2a8hnw52wc22f">Austin</p>
          </div>
          <div data-id="element-1842" data-mp="2f46evk0uoan4">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1843" data-mp="2f4g9jkwub5z5">
              State
            </label>
            <p className="text-gray-900" data-id="element-1844" data-mp="2j5054k1rm1j6">TX</p>
          </div>
          <div data-id="element-1845" data-mp="2o5mmxl4700o6">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1846" data-mp="2o65z0l75vuua">
              Phone #
            </label>
            <p className="text-gray-900" data-id="element-1847" data-mp="2t364ov03mvkv">512-555-0400</p>
          </div>
          <div data-id="element-1848" data-mp="2xx0wklpuygv1">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1849" data-mp="2xybwubk3h6he">
              Fax #
            </label>
            <p className="text-gray-900" data-id="element-1850" data-mp="36wxgyb57stka">512-555-0401</p>
          </div>
        </div>
      </div>

      {/* Signature */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1851" data-mp="3bvgz00gotl7d">
        <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1852" data-mp="108exqwk6kefv">Signature</h3>

        {/* Terms & Conditions */}
        <div className="mb-6" data-id="element-1853" data-mp="v92cuhcvdhfx">
          <h4 className="text-lg font-bold text-gray-900 mb-4" data-id="element-1854" data-mp="v8smgsnwx89p">
            Terms & Conditions
          </h4>
          <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg mb-4" data-id="element-1855" data-mp="r8icl4x01xpk">
            <p className="text-sm text-gray-700 leading-relaxed" data-id="element-1856" data-mp="ma7530u6fzai">
              I understand that should my account become delinquent (terms of
              sale are based upon date of invoice) and that if the creditor
              elects to employ a third party to collect monies due, my company
              will be responsible for not only the original amount billed, but
              also all costs associated with the collection efforts including
              but not limited to reasonable attorney fees. Cash in Advance
              restrictions may be placed on any past due account. Customer will
              notify the creditor, in writing of any ownership changes or legal
              means of doing business by the company under which credit was
              established.
            </p>
          </div>
          <p className="text-sm font-semibold text-gray-900 mb-6" data-id="element-1857" data-mp="1b0vmnq1ebavz">
            By signing the below you give Initech Corporation permission to
            check your bank and trade references.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-x-12 gap-y-6" data-id="element-1858" data-mp="117ev6soqe7vh">
          <div data-id="element-1859" data-mp="1ozvaivh33lr3">
            <label className="text-sm font-medium text-gray-500 mb-2 block" data-id="element-1860" data-mp="1p054eu592d22">
              Signature
            </label>
            <div className="border-2 border-gray-300 rounded-lg p-4 bg-white h-32 flex items-center justify-center" data-id="element-1861" data-mp="1fynp3dzo2fef">
              <svg viewBox="0 0 200 60" className="w-full h-full" style={{
              maxWidth: '200px'
            }} data-id="element-1862" data-mp="1jzpqa0d591j1">
                <path d="M 10 40 Q 20 20, 40 35 T 80 30 Q 100 25, 120 40 T 160 35 Q 170 30, 190 40" stroke="#1f2937" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-1863" data-mp="8ku3ts899vrx" />
              </svg>
            </div>
          </div>
          <div data-id="element-1864" data-mp="ayphs25bzyl9">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1865" data-mp="az8nmkhpiwix">
              Printed Name
            </label>
            <p className="text-gray-900" data-id="element-1866" data-mp="5ykvtwlnmbnn">Peter Gibbons</p>
          </div>
          <div data-id="element-1867" data-mp="3egz76ghv92sy">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1868" data-mp="3egqxexh1idlz">
              Title
            </label>
            <p className="text-gray-900" data-id="element-1869" data-mp="39fjm4ofouwak">Software Engineer</p>
          </div>
          <div data-id="element-1870" data-mp="3o7livzmgp96d">
            <label className="text-sm font-medium text-gray-500 mb-1 block" data-id="element-1871" data-mp="3o83nbjja2tpd">
              Date
            </label>
            <p className="text-gray-900" data-id="element-1872" data-mp="2vppxa646oc0u">2026-02-15</p>
          </div>
        </div>
      </div>
    </div>;
}